export const env = {
  isDev: import.meta.env.DEV,
  apiAddress: import.meta.env.VITE_API_ADDRESS as string,
  uploadFileSizeLimit: Number(import.meta.env.VITE_UPLOAD_FILE_SIZE_LIMIT),
  uploadFileBlockSize: Number(import.meta.env.VITE_UPLOAD_FILE_BLOCK_SIZE),
  uploadFileTypes: import.meta.env.VITE_UPLOAD_FILE_TYPES as string,
  supportEmail: import.meta.env.VITE_SUPPORT_EMAIL as string,
  authLog: import.meta.env.VITE_AUTH_LOG === 'true',
  version: import.meta.env.VITE_VERSION as string,
  bomEditorUrl: import.meta.env.VITE_BOM_EDITOR_URL as string,
} as const;
